import { createAsyncThunk } from '@reduxjs/toolkit';
import { getUserSettings, postUserSettings, putUserSettings } from 'services/api';

export const getUserSettingsAsync: any | null = createAsyncThunk(
  'settings/getUserSettings',
  async () => {
    const response: any = await getUserSettings();
    return response?.data;
  },
);

export const postUserSettingsAsync: any | null = createAsyncThunk(
  'settings/getUserSettings',
  async (data: any) => {
    const response = await postUserSettings(data);
    return response;
  },
);

export const putUserSettingsasync: any | null = createAsyncThunk(
  'settings/getUserSettings',
  async (data: any) => {
    const response = await putUserSettings(data);
    return response;
  },
);
